import React from 'react';

const SpriteSvg = ({ childCss, iconName, ...rest }) => {
    return (
        <svg
            className={`${childCss} icon`}
            focusable="false"
            {...rest}
        >
            <use xlinkHref={`#icon-${iconName}`}></use>
        </svg>
    );
};

SpriteSvg.defaultProps = {
    childCss: '',
};

export default SpriteSvg;
